"use strict";

var _require = require("lodash"),
    isObject = _require.isObject;

var isRangeWithinRange = require("./isRangeWithinRange");
var isPositionWithinRange = require("./isPositionWithinRange");

module.exports = function isRangeOrPositionWithinRange(rangeOrPositionToCheck, containingRange, maxLength, includeStartEdge, includeEndEdge) {

  if (rangeOrPositionToCheck === undefined || rangeOrPositionToCheck === null || containingRange === undefined || containingRange === null) {
    return false;
  }
  if (isObject(rangeOrPositionToCheck)) {
    return isRangeWithinRange(rangeOrPositionToCheck, containingRange, maxLength);
  } else {
    return isPositionWithinRange(rangeOrPositionToCheck, containingRange, maxLength, includeStartEdge, includeEndEdge);
  }
};